import React from 'react';
import styles from './Gallery.module.css';

const Gallery = ({ data }) => {
  if (!data) return null;

  const renderGalleryItem = (item, idx) => {
    // If item has an icon, render icon-based card
    if (item.icon) {
      return (
        <div key={idx} className={styles.galleryCard}>
          <div className={styles.iconContainer}>
            <div className={styles.icon}>{item.icon}</div>
          </div>
          <div className={styles.galleryCaption}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        </div>
      );
    }

    // If item has an image, render image-based card
    if (item.img) {
      return (
        <div key={idx} className={styles.galleryCard}>
          <div className={styles.imageContainer}>
            <img 
              src={item.img} 
              alt={item.alt || item.title} 
              className={styles.galleryImage}
              onError={(e) => {
                // Fallback to placeholder if image fails to load
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className={styles.imagePlaceholder}>
              <div className={styles.placeholderIcon}>📊</div>
              <p>Dashboard Preview</p>
            </div>
          </div>
          <div className={styles.galleryCaption}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        </div>
      );
    }

    // Fallback for text-only items
    return (
      <div key={idx} className={styles.galleryCard}>
        <div className={styles.galleryCaption}>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </div>
      </div>
    );
  };

  return (
    <section id="gallery" className={`${styles.gallerySection} section`}>
      <div className="container">
        <h2 className="section-title fade-in">{data.title}</h2>
        {data.description && (
          <p className={`${styles.galleryDescription} fade-in`}>{data.description}</p>
        )}
        <div className={`${styles.galleryGrid} fade-in`}>
          {data.items?.map(renderGalleryItem)}
        </div>
      </div>
    </section>
  );
};

export default Gallery;


